export const ATHENS_GRAY = "#f2f4f7"; // Athens Gray - paper background color

// MUI v6 Success Palette for Weld165
export const WELD165_COLOR = "#a6d9a8"; // main (medium green)
export const WELD165_COLOR_LIGHT = "#B2DFBA"; // light (for background)
export const WELD165_COLOR_LIGHTER = "#D4EED8"; // lighter (for gradient end)

// Per-line palette for the multi-lane weld gantt (one entry per lane, by sorted order)
export type GanttLineColors = {
	main: string;
	light: string;
	lighter: string;
};

// Green is reserved for Weld165 (its established color), so it is not in the palette.
export const WELD_LINE_PALETTE: GanttLineColors[] = [
	{ main: "#3D8B9E", light: "#BFE0E6", lighter: "#DCEFF3" }, // teal
	{ main: "#9E8B3D", light: "#E6DCB2", lighter: "#F2ECD4" }, // olive gold
	{ main: "#7A4A9E", light: "#D6BFE6", lighter: "#EADCF3" }, // violet
	{ main: "#9E3D5E", light: "#E6BFCC", lighter: "#F3DCE3" }, // burgundy
];

export const WELD165_NAME = "Weld165";

export const WELD165_COLORS: GanttLineColors = {
	main: WELD165_COLOR,
	light: WELD165_COLOR_LIGHT,
	lighter: WELD165_COLOR_LIGHTER,
};

// Work Order Gantt Row Colors (steel blue)
export const WORKORDER_COLOR = "#3D5E9E"; // main
export const WORKORDER_COLOR_LIGHT = "#C5D0E8"; // light (for background)
export const WORKORDER_COLOR_LIGHTER = "#E1E8F4"; // lighter (for gradient end)

// Cutback bundles (set-aside material) — greyed out on every gantt
export const CUTBACK_COLOR = "#9e9e9e"; // main
export const CUTBACK_COLOR_LIGHT = "#e0e0e0"; // light (for background)
export const CUTBACK_COLOR_LIGHTER = "#eeeeee"; // lighter (selected)

// Reclassified bundles (violet) — bottom-band segment showing the new part
export const RECLASSIFIED_COLOR = "#7E57C2"; // main
export const RECLASSIFIED_COLOR_LIGHT = "#D9CCEF"; // light (for background)
export const RECLASSIFIED_COLOR_LIGHTER = "#EDE7F6"; // lighter (selected)

// Gantt Bar Colors
export const GANTT_BORDER_COLOR = "#337D36";
export const GANTT_DELAY_BORDER_COLOR = "#333333";
export const GANTT_HOVER_BG = "#ffefbf";
export const GANTT_HOVER_BG_END = "#fff199";

// Undeclared Delay Row Colors
export const UNDECLARED_DELAY_BG = "#FADBD8";
export const UNDECLARED_DELAY_HOVER_BG = "#E8C8C8";

// Bad Bars Row Colors (Too Long - red pastel)
export const BAD_BARS_BG = "#FBE3E5";
export const BAD_BARS_HOVER_BG = "#EAD3D5";

// Too Short Bar Row Colors (orange pastel)
export const TOO_SHORT_BAR_BG = "#FDDCBF";
export const TOO_SHORT_BAR_HOVER_BG = "#E8CCB2";

// Area Colors (for chips, gantt, identifiers)
// Derived from project base #337D36 — saturated medium, dashboard industrial
export const AREA_COLOR_WELDS = "#4A9E4E"; // green
export const AREA_COLOR_SAWS = "#3D8B9E"; // teal
export const AREA_COLOR_WAX = "#9E8B3D"; // olive gold
export const AREA_COLOR_PAINT = "#3D5E9E"; // steel blue
export const AREA_COLOR_PUNCH = "#9E3D5E"; // burgundy
export const AREA_COLOR_CLIPS = "#7A4A9E"; // violet
// Galv variants: darker shade of their in-house counterpart
export const AREA_COLOR_GALV_SAWED = "#2B616F"; // dark teal
export const AREA_COLOR_GALV_PUNCHED = "#6F2B42"; // dark burgundy
export const AREA_COLOR_GALV_WELDED = "#346F37"; // dark green

// Map AssetId → area color (convention: Welds=10, Saws=20, Wax=30, Paint=40, Punch=50, Clip Presses=60, Galv=70/80/90)
export const AREA_COLOR_MAP: Record<number, string> = {
	10: AREA_COLOR_WELDS,
	20: AREA_COLOR_SAWS,
	30: AREA_COLOR_WAX,
	40: AREA_COLOR_PAINT,
	50: AREA_COLOR_PUNCH,
	60: AREA_COLOR_CLIPS,
	70: AREA_COLOR_GALV_SAWED,
	80: AREA_COLOR_GALV_PUNCHED,
	90: AREA_COLOR_GALV_WELDED,
};
